const get = (key: string): (string | null) => {
  try{
    const localStorageData = localStorage.getItem(key);
    if (localStorageData === null) {
      return null;
    } else {
      return JSON.parse(localStorageData);
    }
  }catch(error){
    return null
  }
};

const set = (key: string, value: string): void => {
  const localStorageData = JSON.stringify(value);
  localStorage.setItem(key, localStorageData);
};

const remove = (key: string): void => {
  localStorage.removeItem(key);
};

const clear = (): void => {
  localStorage.clear();
};

const objectToExport = {
  get: get,
  set: set,
  remove: remove,
  clear: clear,
};

export default objectToExport;
